export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <path
          id="background"
          fill="none"
          fillOpacity="1"
          fillRule="nonzero"
          stroke="none"
          d="M0 0H512V512H0z"
        ></path>
        <path
          id="logo"
          fill="currentColor"
          d="M366.427 76H145.575C107.21 76 76 107.203 76 145.576V366.435C76 404.798 107.21 436 145.575 436h220.86C404.796 436 436 404.798 436 366.435V145.552C435.987 107.192 404.79 76 366.427 76zm19.958 41.486l7.954-.03V178.477l-60.815.194-.207-61.015 53.068-.17zm-181.77 101.558c11.538-15.953 30.24-26.408 51.386-26.408 21.146 0 39.853 10.455 51.369 26.408 7.504 10.413 12 23.164 12 36.95 0 34.938-28.453 63.366-63.377 63.366-34.937 0-63.36-28.428-63.36-63.366.013-13.786 4.488-26.537 11.982-36.95zm196.3 147.375c0 19.036-15.471 34.492-34.49 34.492h-220.85c-19.026 0-34.499-15.455-34.499-34.492V219.044h53.741c-4.644 11.414-7.25 23.882-7.25 36.95 0 54.26 44.151 98.434 98.435 98.434 54.286 0 98.433-44.176 98.433-98.434 0-13.07-2.625-25.536-7.261-36.95h53.742V366.42z"
        ></path>
      </g>
    </svg>
  );
}